'use client';

import Button from '@/components/ui/Button';
import Logo from '@/components/icons/Logo';
import Logos from '@/components/ui/Footer/logos';
import { Dictionary } from '@/app/[lang]/dictonaries';
import Link from 'next/link';
import Image from 'next/image';
import ApplePay from '@/public/icons/apple_pay_icon.svg';
import GooglePay from '@/public/icons/google_pay_icon.svg';
import Visa from '@/public/icons/visa_icon.svg';
import MasterCard from '@/public/icons/master_card_icon.svg';
import AmericanExpress from '@/public/icons/american_express_icon.svg';
import UnionPay from '@/public/icons/union_pay_icon.svg';

export default function Footer({ dict }: { dict: Dictionary }) {
  const handleManageCookies = () => {
    localStorage.removeItem('cookieConsent');
    window.location.reload();
  };

  const shortDays = dict.days.short;

  return (
    <footer className="rounded-t-3xl md:rounded-t-4xl md:items-center w-full min-h-[300px] p-0 md:pt-6 bg-[#213735] flex flex-col text-left relative z-20 -mt-5">
      {/*<div className={"w-full px-0 md:px-6 max-w-[1920px] "} >
                <div className={"bg-[#8abc8f] rounded-3xl md:rounded-xl w-full h-fit md:h-[350px] flex overflow-hidden justify-end pb-44 md:pb-0"} >
                    <div className={"w-fill md:w-1/2 h-full p-5 flex justify-start md:justify-center items-start flex-col"} >
                        <h3 className={"text-xl md:text-3xl font-semibold"} >Get a Free Smoothie<br/>Subscribe to Newsletter</h3>
                        <p className={"mt-1 md:mt-4"} >We'll add a free smoothie to your next order — no strings, just good vibes</p>
                        <EmailForm />
                        <p className={"text-center md:text-left text-sm mt-4"} >We care about protecting you data, read more in our <Button variant={"link"} className={"p-0 h-fit font-semibold text-white"} >privacy policy</Button>.</p>
                    </div>
                </div>
            </div>*/}
      <div
        className={
          'mt-8 grid grid-cols-1 md:grid-cols-4 px-6 text-sm font-medium'
        }
      >
        <div className={'col-span-1 md:col-span-2'}>
          <Logo className={'w-36 h-auto'} />
        </div>
        <div
          className={
            'flex flex-col justify-start items-start focus:ring-0 col-span-1 mt-4 md:mt-0 gap-3 px-2'
          }
        >
          <p className={'text-sm text-white opacity-40'}>
            {dict.components.footer.navigation}
          </p>
          <Link href="/meal-plan">{dict.components.footer.meal_plan}</Link>
          <Link href="/why-calori">{dict.components.navbar.links.why}</Link>
          <Link href="/process">{dict.components.navbar.links.process}</Link>
          <Link href="/blog">{dict.components.navbar.links.blog}</Link>
          <Link href="/faq">{dict.components.navbar.links.faq}</Link>
          <Link href="/contact-us">{dict.components.navbar.links.contact_us}</Link>

          {/*<Link href={"/process"}>Our Process</Link>*/}
          <div className="md:flex hidden flex-col gap-3">
            <p className={'text-sm text-white/40'}>
              {dict.components.footer.support_hours}<br />
            </p>
            <ul className="flex flex-col gap-3">
              <li className="flex items-center gap-2">
                {`${shortDays.mon}, ${shortDays.tue}, ${shortDays.thu}: `}
                <span>9.00–15.00</span>
              </li>
              <li className="flex items-center gap-2">
                {`${shortDays.wed}, ${shortDays.sun}: `}
                <span>14.00–20.00</span>
              </li>
              <li className="flex items-center gap-2">
                {shortDays.fri}, {shortDays.sat}: <span>{dict.components.footer.closed}</span>
              </li>
            </ul>
          </div>
        </div>
        <div
          className={
            'flex flex-col justify-start items-start col-span-1 mt-4 md:mt-0 gap-3 px-2'
          }
        >
          <p className={'text-sm text-white opacity-40'}>
            {dict.components.footer.contacts}
          </p>
          <Link href="mailto:info@calori.fi">info@calori.fi</Link>
          <Link href="mailto:yhteistyo@calori.fi">yhteistyo@calori.fi</Link>
          <Link href="tel:+358503829853">+358 50 382 9853</Link>
          <Link
            target={'_blank'}
            href={
              'https://www.google.com/maps/search/?api=1&query=Nihtisillantie 3 B, 02630 Espoo'
            }
            className={'text-wrap'}
          >
            Nihtisillantie 3 B, 02630 Espoo
          </Link>
          <p className="text-sm">Lagom Food Oy (Calori) - (3165571-2)</p>
          <Logos />
        </div>
        <div className="flex md:hidden flex-col justify-start items-start col-span-1 mt-4 md:mt-0 gap-3">
          <p className="text-sm text-white/40">
            {dict.components.footer.support_hours}<br />
          </p>
          <ul className="flex flex-col gap-3">
            <li className="flex items-center gap-2">
              {`${shortDays.mon}, ${shortDays.tue}, ${shortDays.thu}: `}
              <span>9.00–15.00</span>
            </li>
            <li className="flex items-center gap-2">
              {`${shortDays.wed}, ${shortDays.sun}: `}
              <span>14.00–20.00</span>
            </li>
            <li className="flex items-center gap-2">
              {shortDays.fri}, {shortDays.sat}: <span>{dict.components.footer.closed}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex justify-start flex-wrap gap-4 w-full mt-12 px-6">
        {[
          { icon: ApplePay, alt: 'Apple Pay' },
          { icon: GooglePay, alt: 'Google Pay' },
          { icon: Visa, alt: 'Visa' },
          { icon: MasterCard, alt: 'MasterCard' },
          { icon: AmericanExpress, alt: 'American Express' },
          { icon: UnionPay, alt: 'UnionPay' }
        ].map(({ icon, alt }) => (
          <span key={alt} className="flex items-center justify-center bg-white px-2 rounded-md">
            <Image
              src={icon}
              alt={alt}
              width={35}
              height={45}
              className="object-contain"
            />
          </span>
        ))}
      </div>
      <div className={'mt-12 grid grid-cols-1 md:grid-cols-5 pb-6 px-6 w-full'}>
        <p className={'col-span-1 md:col-span-2 text-white opacity-40'}>
          {dict.components.footer.copyright}
        </p>
        <Button
          variant={'link'}
          className="col-span-1 p-0 h-fit w-fit text-white opacity-40 mt-2 md:mt-0"
        >
          <Link href="/privacy-policy">
            {dict.components.footer.privacy_policy} (FI)
          </Link>
        </Button>
        <Button
          variant={'link'}
          className="col-span-1 p-0 h-fit w-fit text-white opacity-40 mt-2 md:mt-0"
        >
          <Link href="/terms-of-use">
            {dict.components.footer.terms_of_use} (FI)
          </Link>
        </Button>
        <Button
          variant={'link'}
          className="col-span-1 p-0 h-fit w-fit text-white opacity-40 mt-2 md:mt-0"
          onClick={handleManageCookies}
        >
          <Link href="/terms-of-use">
            {dict.components.footer.manage_cookies}
          </Link>
        </Button>
      </div>
    </footer>
  );
}
